var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.TheoPlayer2 = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    return this.player.currentTime
  },

  /** Override to return video duration */
  getDuration: function () {
    return this.player.duration
  },

  /** Override to return current bitrate */
  getBitrate: function () {
    var qty = this.getActiveQuality()
    if (qty && qty.bandwidth) {
      return qty.bandwidth
    } else {
      return -1
    }
  },

  /** Override to return rendition */
  getRendition: function () {
    var qty = this.getActiveQuality()
    if (qty) {
      if (qty.name && isNaN(qty.name)) {
        return qty.name
      } else if (qty.height && qty.width) {
        return Util.buildRenditionString(
          qty.width,
          qty.height,
          qty.bandwidth
        )
      } else {
        return Util.buildRenditionString(qty.bandwidth)
      }
    } else {
      return -1
    }
  },

  /** Override to recurn true if live and false if VOD */
  getIsLive: function () {
    return this.player.live
  },

  /** Override to return resource URL. */
  getResource: function () {
    return this.player.currentSrc
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    var version = 'THEOplayer'
    if (typeof THEOplayer !== 'undefined') {
      version += THEOplayer.version
    } else if (typeof theoplayer !== 'undefined') {
      version += theoplayer.version
    }
    return version
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return 'THEOplayer'
  },

  getActiveQuality: function () {
    var vTracks = this.player.videoTracks
    for (var i = 0; i < vTracks.length; i++) {
      var currentTrack = vTracks.item(i)
      if (currentTrack.enabled) {
        return currentTrack.activeQuality
      }
    }
    return {}
  },

  /** Register listeners to this.player. */
  registerListeners: function () {
    // Console all events if logLevel=DEBUG
    youbora.Util.logAllEvents(this.player)

    // Enable playhead monitor (buffer = true, seek = false)
    this.monitorPlayhead(true, false)

    // Register listeners
    this.player.addEventListener('play', this.playListener.bind(this))
    this.player.addEventListener('playing', this.playingListener.bind(this))
    this.player.addEventListener('pause', this.pauseListener.bind(this))
    this.player.addEventListener('seeking', this.seekingListener.bind(this))
    this.player.addEventListener('ended', this.endedListener.bind(this))
    this.player.addEventListener('error', this.errorListener.bind(this))
    this.player.addEventListener('offline', this.offlineListener.bind(this))
    this.player.addEventListener('adbegin', this.adBeginListener.bind(this))
    this.player.addEventListener('adended', this.adEndedListener.bind(this))
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    this.monitor.stop()

    // unregister listeners
    this.player.removeEventListener('play', this.playListener)
    this.player.removeEventListener('playing', this.playingListener)
    this.player.removeEventListener('pause', this.pauseListener)
    this.player.removeEventListener('seeking', this.seekingListener)
    this.player.removeEventListener('ended', this.endedListener)
    this.player.removeEventListener('error', this.errorListener)
    this.player.removeEventListener('offline', this.offlineListener)
    this.player.removeEventListener('adbegin', this.adBeginListener)
    this.player.removeEventListener('adended', this.adEndedListener)
  },

  /** Listener for 'play' event. */
  playListener: function (e) {
    this.fireStart()
  },

  /** Listener for 'playing' event. */
  playingListener: function (e) {
    this.fireResume()
    this.fireSeekEnd()
    this.fireBufferEnd()
    this.fireJoin()
  },

  /** Listener for 'pause' event. */
  pauseListener: function (e) {
    this.firePause()
  },

  /** Listener for 'seeking' event. */
  seekingListener: function (e) {
    this.fireSeekBegin()
  },

  /** Listener for 'ended' event. */
  endedListener: function (e) {
    this.fireStop()
  },

  /** Listener for 'error' event. */
  errorListener: function (e) {
    this.fireError()
  },

  /** Listener for 'offline' event. */
  offlineListener: function (e) {
    this.fireError("OFFLINE_SOURCE")
  },

  /** Listener for 'adbegin' event. */
  adBeginListener: function (e) {
    //
  },

  /** Listener for 'adended' event. */
  adEndedListener: function (e) {
    //
  }
})

module.exports = youbora.adapters.TheoPlayer2



//////////////////
// WEBPACK FOOTER
// ./src/adapter.js
// module id = 24
// module chunks = 0